module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3Ve6l"))).then(() => parcelRequire('2KbAe'));